import { render, staticRenderFns } from "./WhatsappGroup.vue?vue&type=template&id=f77ca986&"
import script from "./WhatsappGroup.vue?vue&type=script&lang=ts&"
export * from "./WhatsappGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports